import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import Loading from '$/components/loading/Loading';
import * as Bixby from '$/core';
import './index.scss';

interface INewsItem {
  id: string | null;
  category: string;
  title: string;
  date: Date;
  aboutUrl: string;
  hideAboutUrl?: boolean;
  aboutTitle: string;
  description?: string;
  getNewsEntry: (id: string) => Promise<Bixby.Models.News>;
}

const NewsItem: React.FC<INewsItem> = props => {
  const { id, category, title, date, aboutUrl, hideAboutUrl, aboutTitle, getNewsEntry } = props;

  const [showToggle, setShowToggle] = useState(true);

  const [isLoading, setIsLoading] = useState(false);

  const [entry, setEntry] = useState(undefined as undefined | string);

  const retrieveEntry = async () => {
    setShowToggle(false);
    setIsLoading(true);
    try {
      const news: Bixby.Models.News = await getNewsEntry(id ?? '');
      setIsLoading(false);
      setEntry(news.entry);
    } catch (e: any) {
      setIsLoading(false);
    }
  };

  const formatDate = (d: any) => {
    const newsDate = Bixby.Utils.utcDateAsLocal(d);
    return Bixby.Utils.formatDate(newsDate);
  };

  return (
    <div className={classnames('news_item', { active: !showToggle })}>
      <div className="item_category">{category}</div>
      <div className="item_title">{title}</div>
      <div className="item_info">
        {date && formatDate(date)} | About:{' '}
        {hideAboutUrl !== true && (
          <Link to={aboutUrl} className="about_link">
            {aboutTitle}
          </Link>
        )}
        {hideAboutUrl === true && <span>{aboutTitle}</span>}
      </div>
      {Bixby.Utils.isDefined(entry) && (
        <div className="news_item_content">
          <div
            className={classnames('show_print', { expanded: !showToggle })}
            dangerouslySetInnerHTML={{ __html: entry ?? '' }}></div>
        </div>
      )}
      <div onClick={retrieveEntry} className="expand hide_print">
        {showToggle && <span>Read More</span>}
        {isLoading && <Loading inline />}
      </div>
    </div>
  );
};

export default NewsItem;
